import React from "react";
import { List, Datagrid } from "react-admin";

const BulkActionList = ({
    resource,
    perPage = 10,
    sort = { field: "id", order: "ASC" },
    pagination,
    fields,
    bulkActionButtons,
    filter,
    ...props
}) => (
    <List resource={resource} perPage={perPage} sort={sort} pagination={pagination} filter={filter} {...props}>
        <Datagrid bulkActionButtons={bulkActionButtons}>
            {fields.map((FieldComponent, idx) => (
                <FieldComponent.type key={idx} {...FieldComponent.props} />
            ))}
        </Datagrid>
    </List>
);

export default BulkActionList;
